import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnGG: CultureInfo = {
  name: 'en-GG',
  displayName: 'English (Guernsey)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-GG',
  parent: CultureInfoEn
};
